module.exports = __webpack_public_path__ + "4502f606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/transport/car.svg
// module id = 1447
// module chunks = 0 1 15 17 18 19 20 21 22 23 24 32 33 36 37 38